import React from 'react';
import { Check, X } from 'lucide-react';
import { Section } from './Shared';
export const Bitacora = () => {
  const comparison = [{
    situation: 'No sabés por dónde empezar con los 6 tomos',
    without: 'Abrís el Tomo 1 y cerrás sin saber qué sigue',
    with: 'Tenés el ejercicio exacto de cada día'
  }, {
    situation: 'Te saltás días y perdés el hilo',
    without: 'El proceso se corta y no volvés',
    with: 'El Tracker diario te mantiene en curso'
  }, {
    situation: 'Terminás un tomo y no sabés cuál es el siguiente paso',
    without: 'Improvisás o abandonás',
    with: 'La secuencia de 21 días lo decide por vos'
  }, {
    situation: 'Querés medir tu avance real',
    without: 'No tenés forma de verlo',
    with: 'El Checklist por Fase te lo muestra'
  }, {
    situation: 'Necesitás apoyo cuando la emoción te desborda',
    without: 'Estás sola con lo que aparece',
    with: 'El Protocolo de Emergencia te guía paso a paso'
  }, {
    situation: 'Querés cerrar el ciclo de forma consciente',
    without: 'El proceso queda incompleto',
    with: 'El Ritual de Cierre del Día 21 sella el proceso'
  }];
  const checklist = ['Hoja de Ruta de 21 días dividida en 3 Fases', 'Ejercicio diario de 10 a 15 minutos por día', 'Pregunta de cierre nocturno para cada día', 'Tracker de estado emocional diario', 'Checklists de cierre por Fase', 'Protocolo de Emergencia Emocional', 'Protocolo de Blindaje Matutino', 'Protocolo de Limpieza Rápida de Campo', 'Mapa de Vínculos e Inventario de Creencias', 'Manifiesto del Campo Limpio', 'Glosario Akáshico Básico', 'Carta a tu Yo de dentro de 90 días', 'Ritual de Cierre Oficial del Día 21'];
  return <Section data-id="element-14">
      <div className="text-center mb-12" data-id="element-15">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[23px]" data-id="element-16">
          <span className="mr-3" data-id="element-17">🕊️</span> ¿QUÉ AGREGA LA BITÁCORA DE 21 DÍAS?
        </h2>
      </div>

      {/* Desktop: 3-column grid */}
      <div className="hidden md:block" data-id="element-18">
        <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-19">
          <div className="font-serif font-bold text-lg text-brand-text/80" data-id="element-20">
            Situación
          </div>
          <div className="font-serif font-bold text-lg text-red-400 flex items-center" data-id="element-21">
            <X className="w-5 h-5 mr-2" data-id="element-22" /> Sin Bitácora
          </div>
          <div className="font-serif font-bold text-lg text-brand-gold flex items-center" data-id="element-23">
            <Check className="w-5 h-5 mr-2" data-id="element-24" /> Con Bitácora
          </div>
        </div>
        <div className="space-y-3" data-id="element-25">
          {comparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 glass-panel p-4 rounded-xl items-center" data-id="element-26">
              <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-27">
                {row.situation}
              </div>
              <div className="text-sm text-brand-text/60 pr-4" data-id="element-28">
                {row.without}
              </div>
              <div className="text-sm text-brand-gold/90 font-medium bg-brand-gold/10 p-3 rounded-lg border border-brand-gold/20" data-id="element-29">
                {row.with}
              </div>
            </div>)}
        </div>
      </div>

      {/* Mobile: stacked cards */}
      <div className="md:hidden space-y-4" data-id="element-30">
        {comparison.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl space-y-3" data-id="element-31">
            <p className="text-sm font-medium text-brand-text/90" data-id="element-32">
              {row.situation}
            </p>
            <div className="flex items-start space-x-2" data-id="element-33">
              <X className="w-4 h-4 text-red-400 mt-0.5 shrink-0" data-id="element-34" />
              <span className="text-sm text-brand-text/60" data-id="element-35">{row.without}</span>
            </div>
            <div className="flex items-start space-x-2 bg-brand-gold/10 p-3 rounded-lg border border-brand-gold/20" data-id="element-36">
              <Check className="w-4 h-4 text-brand-gold mt-0.5 shrink-0" data-id="element-37" />
              <span className="text-sm text-brand-gold/90 font-medium" data-id="element-38">
                {row.with}
              </span>
            </div>
          </div>)}
      </div>

      <div className="mt-16 max-w-3xl mx-auto glass-panel p-8 md:p-10 rounded-3xl border-brand-gold/30 relative overflow-hidden" data-id="element-39">
        <div className="absolute top-0 left-0 w-full h-1 gold-gradient-bg" data-id="element-40"></div>
        <h3 className="text-2xl font-serif font-bold mb-8 flex items-center" data-id="element-41">
          <Check className="w-6 h-6 text-brand-gold mr-3" data-id="element-42" /> La Bitácora
          incluye:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-43">
          {checklist.map((item, i) => <div key={i} className="flex items-start" data-id="element-44">
              <div className="w-1.5 h-1.5 rounded-full bg-brand-gold mt-2 mr-3 shrink-0" data-id="element-45"></div>
              <span className="text-brand-text/80 text-sm leading-relaxed" data-id="element-46">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </Section>;
};